import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components/macro';
import { Helmet } from 'react-helmet-async';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { signUp } from '../../redux/actions/authActions';

import {
  Button,
  Paper,
  TextField as MuiTextField,
  Typography,
  Select as MuiSelectField,
  MenuItem,
  InputLabel,
  FormHelperText,
  FormControl as MuiFormControl,
  Grid,
} from '@material-ui/core';
import { spacing } from '@material-ui/system';
import { Alert as MuiAlert } from '@material-ui/lab';
import { newUser } from '../../services/usersServices';

import {
  getListByComponent,
  updateListByComponent,
} from '../../services/genericServices';
import { Casino } from '../../types/casinos';
import { AuthContextType, AuthContext } from '../../context/authContext';
import { PageContainer } from '../components/PageContainer';
const Alert = styled(MuiAlert)(spacing);

const TextField = styled(MuiTextField)<{ my?: number }>(spacing);
const SelectField = styled(MuiSelectField)<{ my?: number }>(spacing);
const ControlField = styled(MuiFormControl)<{ my?: number }>(spacing);

const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)}px;

  ${(props) => props.theme.breakpoints.up('md')} {
    padding: ${(props) => props.theme.spacing(10)}px;
  }
`;
interface BaccaratTable {
  game: string;
  typeBets: {
    main: { minBet: number; maxBet: number };
    behind: { minBet: number; maxBet: number };
  };
  profit: {
    blackjack: string;
    insurance: string;
    win: string;
  };
  waitingTime: { initGame: number; decision: number; insurance: number };
  chips: Array<number>;
  viewers: number;
  isOpen: boolean;
  dealer: string;
  tablePicture: string;
  streamAuthorizationToken: string;
  streamName: string;
  streamAccountId: string;
  gameType: string;
  tableNumber: number;
  version: number;
  createdAt: string;
  updatedAt: string;
  casino?: string;
}
function UpdateBlackjackTable(props: any) {
  const history = useHistory();
  const [opts, setOpts] = React.useState<any>([]);
  const [form, setForm] = React.useState<BaccaratTable>({
    typeBets: {
      main: { minBet: 100, maxBet: 1000 },
      behind: { minBet: 100, maxBet: 1000 },
    },
    chips: [1, 10, 50, 100, 500, 1000],
    game: 'blackjack',
    profit: { blackjack: '3:2', insurance: '2:1', win: '1:1' },
    waitingTime: { initGame: 20, decision: 20, insurance: 20 },
    dealer: 'Ruby',
    viewers: 0,
    isOpen: false,
    tablePicture: 'https://demo.lasvegasenvivo.com/TableScreenshots/9901.jpg',
    streamAuthorizationToken: '',
    streamName: 'kdaihneo',
    streamAccountId: 'sanZE3',
    gameType: 'regular',
    tableNumber: 9901,
    version: 0,
    createdAt: '2021-05-17T23:04:42.265Z',
    updatedAt: '2021-05-31T16:42:13.383Z',
  });
  const { hasRole } = React.useContext<AuthContextType>(AuthContext);
  const [loading, setLoading] = React.useState<any>(false);
  const onSubmit = async (
    values: object,
    { setErrors, setStatus, setSubmitting }: any
  ) => {
    try {
      console.log(values);
      setSubmitting(true);
      await updateListByComponent(
        `table/blackjack/${props.match.params.id}`,
        values
      );
      setStatus({ success: true });
      setSubmitting(false);
      history.push('/table/list');
    } catch (error: any) {
      const message = error.message || 'Algo salió mal. Intente nuevamente.';
      setStatus({ success: false });
      setErrors({ submit: message });
      setSubmitting(false);
    }
  };
  React.useEffect(() => {
    (async () => {
      let formUpdated: any = await getListByComponent(
        `/admin/table/${props.match.params.id}`
      );
      if (formUpdated.status == 200) {
        formUpdated = formUpdated.data;
        setForm({
          ...formUpdated,
        });
        console.log(form, formUpdated, 'form');
        setLoading(true);
      }
    })();

    return () => {};
  }, []);

  React.useEffect(() => {
    if (hasRole(['superadmin'])) {
      (async () => {
        let gameTableResponse: Array<Casino> = [];
        let { data, status } = await getListByComponent('/admin/casino');
        if (status == 200) {
          gameTableResponse = data;
          setOpts(
            gameTableResponse.map(({ _id, name }) => ({
              value: _id,
              label: name,
            }))
          );
          setForm((form) => ({ ...form, casino: '' }));
        }
      })();
    }
    return () => {};
  }, []);
  return (
    <PageContainer
      headerTitle="Mesas de Juego"
      headerPath="/tables"
      title={'Actualiza Mesa de Juego'}
      path="dealers/create"
    >
      <Typography component="h1" variant="h4" align="center" gutterBottom>
        Actualiza una Mesa de Juego
      </Typography>
      <Typography component="h2" variant="body1" align="center">
        Utiliza esta herramienta para actualizar una Mesa de Juego
      </Typography>
      {loading ? (
        <Formik
          enableReinitialize
          initialValues={form}
          validationSchema={Yup.object().shape({
            game: Yup.string()
              .max(255)
              .required('Se requiere un nombre de juego'),
            gameType: Yup.string()
              .max(255)
              .required('Se requiere un tipo de juego'),
            tableNumber: Yup.string()
              .max(255)
              .required('Se requiere un numero de mesa'),
            typeBets: Yup.object().shape({
              main: Yup.object().shape({
                minBet: Yup.number()
                  .min(1, 'la apuesta minuma debe sermayor a 1')
                  .integer('Solo números. Debe ser un telefono válido.'),
                maxBet: Yup.number()
                  .min(2, 'la apuesta minuma debe sermayor a 2')
                  .integer('Solo números. Debe ser un telefono válido.'),
              }),
              behind: Yup.object().shape({
                minBet: Yup.number()
                  .min(1, 'la apuesta minuma debe sermayor a 1')
                  .integer('Solo números. Debe ser un telefono válido.'),
                maxBet: Yup.number()
                  .min(2, 'la apuesta minuma debe sermayor a 2')
                  .integer('Solo números. Debe ser un telefono válido.'),
              }),
            }),
            dealer: Yup.string().max(255).required('Se requiere un nombre'),
            streamName: Yup.string().max(255).required('Se requiere un nombre'),
            streamAccountId: Yup.string()
              .max(255)
              .required('Se requiere un nombre'),
          })}
          onSubmit={onSubmit}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            isSubmitting,
            touched,
            values,
          }) => (
            <form noValidate onSubmit={handleSubmit}>
              <Grid container spacing={6}>
                <Grid item md={6}>
                  <TextField
                    variant="outlined"
                    type="text"
                    name="game"
                    label="game"
                    value={values.game}
                    error={Boolean(touched.game && errors.game)}
                    fullWidth
                    helperText={touched.game && errors.game}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    my={3}
                  />
                </Grid>
                <Grid item md={6}>
                  <TextField
                    variant="outlined"
                    type="text"
                    name="dealer"
                    label="Nombre de dealer"
                    value={values.dealer}
                    error={Boolean(touched.dealer && errors.dealer)}
                    fullWidth
                    helperText={touched.dealer && errors.dealer}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    my={3}
                  />
                </Grid>
                <Grid item md={6}>
                  <TextField
                    variant="outlined"
                    type="text"
                    name="gameType"
                    label="tipo de juego"
                    value={values.gameType}
                    error={Boolean(touched.gameType && errors.gameType)}
                    fullWidth
                    helperText={touched.gameType && errors.gameType}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    my={3}
                  />
                </Grid>
                <Grid item md={6}>
                  <TextField
                    variant="outlined"
                    type="number"
                    name="tableNumber"
                    label="Numero de Mesa"
                    value={values.tableNumber}
                    error={Boolean(touched.tableNumber && errors.tableNumber)}
                    fullWidth
                    helperText={touched.tableNumber && errors.tableNumber}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    my={3}
                  />
                </Grid>
                <Grid item md={6}>
                  <TextField
                    variant="outlined"
                    type="number"
                    name="typeBets.main.minBet"
                    label="Apuesta minima main"
                    value={values.typeBets?.main?.minBet}
                    error={Boolean(
                      touched.typeBets?.main?.minBet &&
                        errors.typeBets?.main?.minBet
                    )}
                    fullWidth
                    helperText={
                      touched.typeBets?.main?.minBet &&
                      errors.typeBets?.main?.minBet
                    }
                    onBlur={handleBlur}
                    onChange={handleChange}
                    my={3}
                  />
                </Grid>
                <Grid item md={6}>
                  <TextField
                    variant="outlined"
                    type="number"
                    name="typeBets.main.maxBet"
                    label="Apuesta maxima main"
                    value={values.typeBets?.main?.maxBet}
                    error={Boolean(
                      touched.typeBets?.main?.maxBet &&
                        errors.typeBets?.main?.maxBet
                    )}
                    fullWidth
                    helperText={
                      touched.typeBets?.main?.maxBet &&
                      errors.typeBets?.main?.maxBet
                    }
                    onBlur={handleBlur}
                    onChange={handleChange}
                    my={3}
                  />
                </Grid>

                <Grid item md={6}>
                  <TextField
                    variant="outlined"
                    type="number"
                    name="typeBets.behind.minBet"
                    label="Apuesta minima behind"
                    value={values.typeBets?.behind?.minBet}
                    error={Boolean(
                      touched.typeBets?.behind?.minBet &&
                        errors.typeBets?.behind?.minBet
                    )}
                    fullWidth
                    helperText={
                      touched.typeBets?.behind?.minBet &&
                      errors.typeBets?.behind?.minBet
                    }
                    onBlur={handleBlur}
                    onChange={handleChange}
                    my={3}
                  />
                </Grid>
                <Grid item md={6}>
                  <TextField
                    variant="outlined"
                    type="number"
                    name="typeBets.behind.maxBet"
                    label="Apuesta maxima behind"
                    value={values.typeBets?.behind?.maxBet}
                    error={Boolean(
                      touched.typeBets?.behind?.maxBet &&
                        errors.typeBets?.behind?.maxBet
                    )}
                    fullWidth
                    helperText={
                      touched.typeBets?.behind?.maxBet &&
                      errors.typeBets?.behind?.maxBet
                    }
                    onBlur={handleBlur}
                    onChange={handleChange}
                    my={3}
                  />
                </Grid>

                <Grid item md={6}>
                  <TextField
                    variant="outlined"
                    type="text"
                    name="streamName"
                    label="Stream Name"
                    value={values.streamName}
                    error={Boolean(touched.streamName && errors.streamName)}
                    fullWidth
                    helperText={touched.streamName && errors.streamName}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    my={3}
                  />
                </Grid>
                <Grid item md={6}>
                  <TextField
                    variant="outlined"
                    type="text"
                    name="streamAccountId"
                    label="stream Account Id"
                    value={values.streamAccountId}
                    error={Boolean(
                      touched.streamAccountId && errors.streamAccountId
                    )}
                    fullWidth
                    helperText={
                      touched.streamAccountId && errors.streamAccountId
                    }
                    onBlur={handleBlur}
                    onChange={handleChange}
                    my={3}
                  />
                </Grid>
                {hasRole(['superadmin']) ? (
                  <Grid item md={12}>
                    <ControlField my={3} fullWidth variant="outlined">
                      <InputLabel id={'casino'}>Casino</InputLabel>
                      <SelectField
                        labelId={'casino'}
                        id={'casino'}
                        name={'casino'}
                        value={values.casino}
                        fullWidth
                        onBlur={handleBlur}
                        onChange={handleChange}
                      >
                        {opts.map((option: any) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </SelectField>
                      {props.error && (
                        <FormHelperText>
                          Por favor indique una opcion
                        </FormHelperText>
                      )}
                    </ControlField>
                  </Grid>
                ) : null}
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  disabled={isSubmitting}
                >
                  Actualizar Mesa
                </Button>
              </Grid>
            </form>
          )}
        </Formik>
      ) : null}
    </PageContainer>
  );
}

export default UpdateBlackjackTable;
